module.exports = __webpack_public_path__ + "img/pizza.2abc0922.jpg";